import { describeFields, FieldWidget } from '../common/fields';
import { LessonTemplateSchema } from './schemas';

export const LESSON_TEMPLATE_FIELDS = describeFields(LessonTemplateSchema, {
  courseId: { widget: FieldWidget.Select },
  code: {},
  lessonGroup: {},
  label: {},
  lessonType: {},
  isTimesheeted: {},
  homeworkRequired: {},
  questionSetId: { widget: FieldWidget.Autocomplete, displayField: 'questionSetTitle' },
  active: {},
});
